<form [formGroup]="repairPartFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-multi-select
            label="Mode"
            fit="medium"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="repairModeList">
            @for (mode of repairModeList; track mode.value) {
              <mc-option [value]="mode.value">{{ mode.label }}</mc-option>
            }
          </mc-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-typeahead-multi-select
            label="Repair Code"
            placeholder="Type or select repair code"
            fit="medium"
            width="100%"
            name="repairCode"
            maxoptions="100"
            optionsheight="400px"
            [data]="repairCodeTypeaheadData"
            [selecteddata]="selectedRepairCodes"
            (optionselected)="onRepairCodeSelected($event)"
            (clearbuttonclick)="onRepairCodeCleared()">
          </mc-typeahead-multi-select>
        </div>
      </div>
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-typeahead-multi-select
            label="Part Number"
            placeholder="Type or select part number"
            fit="medium"
            width="100%"
            name="partCode"
            maxoptions="100"
            optionsheight="400px"
            [data]="partCodeTypeaheadData"
            [selecteddata]="selectedPartCodes"
            (optionselected)="onPartCodeSelected($event)"
            (clearbuttonclick)="onPartCodeCleared()">
          </mc-typeahead-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <div style="display: flex; gap: 8px; align-items: flex-end">
            <mc-select
              label="Max Part Qty"
              fit="medium"
              style="flex: 1"
              placeholder="Select"
              ngDefaultControl
              formControlName="maxQuantityOperator">
              @for (op of maxQuantityOperatorList; track op.code) {
                <mc-option [value]="op.code">{{ op.description }}</mc-option>
              }
            </mc-select>
            <mc-input
              hiddenlabel
              placeholder="Value"
              fit="medium"
              style="flex: 1"
              ngDefaultControl
              formControlName="maxQuantityValue"
              type="number">
            </mc-input>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      (keydown.enter)="applyFilters()"
      (keydown.space)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      (keydown.enter)="clearFilters()"
      (keydown.space)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
